import React from "react";
import Hero from "../Components/Hero";
import Products from "../Components/Products";
import References from "../Components/References";

const Home = () => {
  return (
    <div>
      <Hero />
      <References />
      <Products />
    </div>
  );
};

export default Home;
